import { defineComponent as _defineComponent } from 'vue'
import ButtonSpinner from "./ButtonSpinner.vue";
import { computed } from "vue";

export type BButtonColor = 'red' | 'white' | 'blue';
export type BButtonVariant = 'primary' | 'secondary';



export default /*#__PURE__*/_defineComponent({
  __name: 'BButton',
  props: {
    color: { default: 'red' },
    variant: { default: 'primary' },
    minimal: { type: Boolean },
    href: null,
    disabled: { type: [Boolean, String] },
    loading: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'click', $event: MouseEvent): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { color: BButtonColor, variant: BButtonVariant, minimal?: boolean, href?: string, disabled?: boolean | 'not-greyed-out', loading?: boolean }





function handleClick($event: MouseEvent) {
	if (props.loading || props.disabled) {
		$event.stopPropagation();
		return;
	}
	emit('click', $event);
}

const tagName = computed(() => !!props.href ? 'a' : 'button');


return { __sfc: true,props, emit, handleClick, tagName, ButtonSpinner }
}

})